import { Component, forceUpdate, getAssetPath, h, Host, Prop } from '@stencil/core';
import { AuthConfig } from './models/AuthConfig';
import { IDP } from './models/IDP';
import { shuffle } from 'lodash';
import axios from 'axios';

declare var window: { CodCat: string, location: { href: string, hostname: string, search: any, origin: string } };

@Component({
  tag: 'starch-login',
  styleUrl: 'starch-login.css',
  shadow: true,
})
export class StarchLogin {
  @Prop() codCat: string;
  @Prop({attribute: 'mostraavvisocportal360'}) showCPortal360Alert: string;
  @Prop({attribute: 'disabilitacns'}) disableCns: string;

  returnUrl: string;
  config: AuthConfig;
  assetsUrl: string;
  showSpidDropdown: boolean;
  spidIdps: IDP[];
  currentTab: number;

  constructor() {
    this.returnUrl = '/';
    this.codCat = window.CodCat ?? '';

    this.config = {
      id: 0,
      codcat: '',
      idP_SPID: false,
      idP_CIE: false,
      idP_EIDAS: false,
      idP_GEL: false,
      loginWithPassword: false
    };
    this.spidIdps = [
      {
        id: 'infocert',
        name: 'Infocert',
        image: 'spid-idp-infocertid.png',
      },
      {
        id: 'namirial',
        name: 'Namirial',
        image: 'spid-idp-namirialid.png',
      },
      {
        id: 'teamsystem',
        name: 'TeamSystemId',
        image: 'spid-idp-teamsystemid.png',
      },
      {
        id: 'Lepida',
        name: 'Lepida',
        image: 'spid-idp-lepidaid.png',
      },
      {
        id: 'tim',
        name: 'Tim',
        image: 'spid-idp-timid.png',
      },
      {
        id: 'register',
        name: 'Register',
        image: 'spid-idp-spiditalia.png',
      },
      {
        id: 'intesigroup',
        name: 'IntesiGroupSpid',
        image: 'spid-idp-intesigroupspid.png',
      },
      {
        id: 'infocamere',
        name: 'Infocamere',
        image: 'spid-idp-infocamereid.png',
      },
      {
        id: 'poste',
        name: 'Poste',
        image: 'spid-idp-posteid.png',
      },
      {
        id: 'aruba',
        name: 'Aruba',
        image: 'spid-idp-arubaid.png',
      },
      {
        id: 'sielte',
        name: 'Sielte',
        image: 'spid-idp-sielteid.png',
      },
      {
        id: 'eht',
        name: 'EtnaID',
        image: 'spid-idp-etnaid.png',
      },
    ];
    this.spidIdps = shuffle(this.spidIdps);
    this.showSpidDropdown = false;
    this.currentTab = 2;
    this.showCPortal360Alert = "";
    this.disableCns = "";
  }

  componentDidLoad(): void {
    const urlParams = new URLSearchParams(window.location.search);
    const cleanReturnUrl = urlParams.get('returnurl') ? window.location.origin + urlParams.get('returnurl') : window.location.origin;
    this.returnUrl = btoa(decodeURI(cleanReturnUrl));
    this.getAuthConfig();
  }

  async getAuthConfig() {
    const res = await axios.get<AuthConfig>(`https://auth.cportal.it/LoginProviders/${this.codCat}`, { method: 'get' });
    this.config = res.data;
    forceUpdate(this);
    if (this.config.idP_CIE || this.config.idP_GEL) this.currentTab = 1;
    if (this.config.idP_SPID || this.config.idP_GEL) this.currentTab = 0;
    forceUpdate(this);
  }

  getAuthUrl(type: 'spid' | 'cie' | 'cns' | 'eidas', provider?: string) {
    let base = '';
    if (this.config.idP_GEL) {
      base = 'IDPCRL';
      provider = 'GEL';
    } else {
      switch (type) {
        case 'spid':
          base = 'SPID';
          break;
        case 'cie':
          base = 'CIE';
          provider = 'CIE';
          break;
        case 'cns':
          base = 'IDPCRL';
          provider = 'CRS';
          break;
        case 'eidas':
          base = 'SPID';
          provider = 'eidas';
      }
    }
    return `https://auth.cportal.it/${base}/Login/${this.codCat}/${provider}/?SP_DataConsumerUrl=${this.returnUrl}`;
  }

  goToAuth(type: 'spid' | 'cie' | 'cns' | 'eidas', provider?: string) {
    window.location.href = this.getAuthUrl(type, provider);
  }

  switchTab(tab: number) {
    this.currentTab = tab;
    forceUpdate(this);
  }

  render() {

    return (
      <Host>
        <div class="login-container border border-solid border-gray-500 shadow-md shadow-black/30 my-6 mx-3 md:mx-auto">
          <ul class="tabs">
            {(this.config.idP_SPID || this.config.idP_GEL) &&
              <li class={`tab ${this.currentTab === 0 ? 'active' : ''}`}>
                <button type="button" class="text-2xl font-semibold" onClick={() => this.switchTab(0)}>SPID</button>
              </li>
            }
            {(this.config.idP_CIE || this.config.idP_GEL) &&
              <li class={`tab ${this.currentTab === 1 ? 'active' : ''}`}>
                <button type="button" class="text-2xl font-semibold" onClick={() => this.switchTab(1)}>CIE</button>
              </li>
            }
            {this.disableCns !== "1" &&
              <li class={`tab ${this.currentTab === 2 ? 'active' : ''}`}>
              <button type="button" class="text-2xl font-semibold" onClick={() => this.switchTab(2)}>CNS</button>
            </li>
            }
            {this.config.idP_EIDAS &&
              <li class={`tab ${this.currentTab === 3 ? 'active' : ''}`}>
                <button type="button" class="text-2xl font-semibold" onClick={() => this.switchTab(3)}>eIDAS</button>
              </li>
            }
            {this.config.loginWithPassword &&
              <li class={`tab ${this.currentTab === 4 ? 'active' : ''}`}>
                <button type="button" class="text-2xl font-semibold" onClick={() => this.switchTab(4)}>Password</button>
              </li>
            }
          </ul>

          <div class="tab-content">
            {this.currentTab === 0 && (
              <div>
                <p>
                  SPID, il <strong>Sistema Pubblico di Identità Digitale</strong>, è il sistema di accesso che consente
                  di
                  utilizzare, con un'identità digitale unica, i servizi online della Pubblica Amministrazione e dei
                  privati
                  accreditati. Se sei già in possesso di un'identità digitale, accedi con le credenziali del tuo
                  gestore.
                  Se
                  non hai ancora un'identità digitale, richiedila ad uno dei gestori.
                </p>
                <div class="flex flex-col gap-3 items-start md:flex-row md:items-center justify-between mt-4">
                  <div>
                    <div class="flex flex-col">
                      <a class="underline block py-1" target="_blank" href="https://www.spid.gov.it">Maggiori
                        informazioni</a>
                      <a class="underline block py-1" target="_blank"
                         href="https://www.spid.gov.it/richiedi-spid">Non hai SPID?</a>
                      <a class="underline block py-1" target="_blank"
                         href="https://www.spid.gov.it/serve-aiuto">Serve
                        aiuto?</a>
                    </div>
                  </div>
                  <div class="dropdown relative">
                    <button class="spid-cie-button" type="button"
                            onClick={() => {
                              this.showSpidDropdown = !this.showSpidDropdown;
                              forceUpdate(this);
                            }}>
                      <div class="flex items-center space-x-4 px-4">
                        <span class="border-r border-solid border-white pr-3">
                          <img src={getAssetPath('../assets/images/spid.png')} alt="SPID" />
                        </span>
                        <span>Entra con SPID</span>
                      </div>
                    </button>
                    <ul
                      class={`dropdown-menu spid-dropdown absolute shadow-md bg-white z-[100] ${this.showSpidDropdown ? '' : 'hidden'}`}
                      aria-labelledby="spidDropdown">
                      {this.spidIdps.map((idp) => <li class="dropdown-item spid-idp-button-link">
                        <button
                          type="button"
                          onClick={() => this.goToAuth('spid', idp.id)}
                          class="home-box-fornitore border-b"
                          aria-label={idp.name}
                        >
                          <span class="sr-only">{idp.name}</span>
                          <img src={getAssetPath(`../assets/images/IDP/${idp.image}`)} alt={idp.name} />
                        </button>
                      </li>)}
                    </ul>
                  </div>
                </div>
                <img class="spid-agid mt-6 mx-auto block" src={getAssetPath('../assets/images/spid-agid.png')}
                     alt="Spid Agid" />
              </div>
            )}

            {this.currentTab === 1 && (
              <div>
                <p>
                  La <strong>Carta di Identità Elettronica (CIE) </strong>è il documento personale che attesta
                  l'identità
                  del cittadino.
                  Dotata di microprocessore, oltre a comprovare l'identità personale, permette l'accesso ai servizi
                  digitali della Pubblica Amministrazione.
                </p>
                <div class="flex flex-col gap-3 items-start md:flex-row md:items-center justify-between mt-4">
                  <div>
                    <a class="underline block py-1" target="_blank"
                       href="https://www.cartaidentita.interno.gov.it/">Maggiori
                      informazioni</a>
                  </div>
                  <div>
                    <button type="button" class="spid-cie-button" onClick={() => this.goToAuth('cie')}>
                    <span class="flex flex-row items-center">
                    <div class="flex items-center space-x-4 px-4">
                      <span class="border-r border-solid border-white/50 pr-3">
                        <img src={getAssetPath('../assets/images/cie.png')} alt="CIE" class="btn-icon" />
                      </span>
                      <span>Entra con CIE</span>
                    </div>
                  </span>
                    </button>
                  </div>
                </div>
              </div>
            )}

            {this.currentTab === 2 && (
              <div>
                <p>
                  L'accesso è consentito con la <strong>Tessera Sanitaria (TS)</strong> e la <strong>Carta Nazionale dei
                  Servizi (CNS)</strong>.
                  La TS e la CNS sono smart card che contengono un "certificato digitale" di autenticazione personale,
                  utile per accedere ai servizi online della Pubblica Amministrazione.
                </p>
                <div class="flex flex-col gap-3 items-start md:flex-row md:items-center justify-between mt-4">
                  <div>
                    <a class="underline block py-1" target="_blank"
                       href="https://sistemats1.sanita.finanze.it/portale/web/guest">Maggiori
                      informazioni</a>
                  </div>
                  <div>
                    <button type="button" class="cns-button" onClick={() => this.goToAuth('cns')}>
                      <div class="flex items-center space-x-4 px-4">
              <span class="border-r border-solid border-white pr-3">
                <img src={getAssetPath('../assets/images/ts-cns.png')} alt="CNS" class="btn-icon" />
              </span>
                        <span>Entra con CNS</span>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            )}

            {this.currentTab === 3 && (
              <div>
                <p>
                  Sign in with a digital identity from another European Country.<br />
                  <strong>eIDAS </strong>allows European citizens to access Italian online public services with their
                  national digital identity.
                </p>
                <div class="flex flex-col gap-3 items-start md:flex-row md:items-center justify-between mt-4">
                  <div>
                  <a class="underline block py-1" target="_blank"
                     href="https://www.eid.gov.it/">Learn more about eIDAS</a>
                  </div>
                <div>
                  <button class="spid-cie-button" onClick={() => this.goToAuth('eidas')}>
                    <div class="flex items-center space-x-4 px-4">
                    <span class="border-r border-solid border-white pr-3">
                      <img src={getAssetPath('../assets/images/eidas.png')} alt="eIDAS" class="btn-icon" />
                    </span>
                      <span>Login with eIDAS</span>
                    </div>
                  </button>
                </div>
                </div>
              </div>
            )}

            {this.currentTab === 4 && (
              <div>
                <p>
                  In ottemperanza al Decreto Legge n. 76/2020, dal giorno 1/3/2021 non è più consentito effettuare nuove registrazioni indicando Login e Password. I nuovi utenti possono accedere al portale usando gli strumenti di identità digitale (SPID, CNS, CIE). Coloro che, alla data del 1/3/2021, fossero già provvisti di login e password potranno comunque continuare ad utilizzarle fino al 30/09/2021.
                </p>
                <div class="flex flex-col gap-3 items-start md:flex-row md:items-center justify-end mt-4">
                  <div>
                    <button class="spid-cie-button" onClick={() => window.location.href = '/Accesso-idm'}>
                      <div class="flex items-center space-x-4 px-4">
                    <span class="border-r border-solid border-white pr-3">
                      <img src={getAssetPath('../assets/images/spid.png')} alt="Password" class="btn-icon" />
                    </span>
                        <span>Accedi con password</span>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        {this.showCPortal360Alert === "1" &&
          <div class="login-container shadow-md my-6 mx-3 md:mx-auto">
        <p class="mb-3">
          <span class="font-semibold">Il portale attualmente in uso presso questo Comune è la nuova versione di CPortal, ovvero CPortal 360.</span><br />
          Se ti sei già registrato con la precedente versione di CPortal per un altro comune <span class="font-semibold uppercase">dovrai registrarti nuovamente per utilizzare CPortal 360.</span><br />
          La registrazione dovrà essere eseguita una sola volta e ti permetterà di accedere a CPortal 360 di tutti i comuni.
        </p>
        <a href='/portals/_default/Immagini/CPortalvsCportal360.jpg' target="_blank" class="font-semibold">Come faccio a riconoscere CPortal da CPortal 360?</a>
      </div>
        }
      </Host>
    );
  }
}
